import React, { useState, useCallback, useEffect } from "react";
import axios from "axios";
import { Collapse, Tag, Typography, message } from "antd";
import { ModalItem, ButtonItem } from "./Items";

const { Text } = Typography;

//Modal que muestra en qué ubicación quedó guardado cada insumo recibido
const ModalUbicacionesConfirmadas = ({ visible, onClose, empresaId, headersToken, documentoOrigenId, documentoOrigenTipo = "OrdenDeCompra" }) => {
  const esFactura = documentoOrigenTipo === "FacturaSinOrdenDeCompra";
  const rutaBase = esFactura ? "facturassinordendecompra" : "ordenesdecompra";
  const campoIdOrigen = esFactura ? "facturaId" : "ordenDeCompraId";

  const [cargando, setCargando] = useState(false);
  const [datos, setDatos] = useState(null);

  const cargarDatos = useCallback(() => {
    if (!documentoOrigenId) return;
    setCargando(true);
    axios
      .post(`${rutaBase}/datosUbicacionesConfirmadas`, { empresaId, [campoIdOrigen]: documentoOrigenId }, { headers: headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          setDatos(res.data);
        } else {
          setDatos(null);
          if (res.data.success === 1) {
            message.info(res.data.message || "No hay recepciones registradas");
          } else {
            message.error(res.data.message || "No se pudieron consultar las ubicaciones");
          }
        }
      })
      .catch(() => message.error("No se pudieron consultar las ubicaciones"))
      .finally(() => setCargando(false));
  }, [empresaId, headersToken, documentoOrigenId, rutaBase, campoIdOrigen]);

  useEffect(() => {
    if (visible) cargarDatos();
  }, [visible, documentoOrigenId, cargarDatos]);

  return (
    <ModalItem
      title="Ubicaciones de los insumos recibidos"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={720}
      spinning={cargando}
    >
      {!datos ? (
        !cargando && (
          <div style={{ padding: "20px 0" }}>
            <Text type="secondary">No hay recepciones registradas.</Text>
          </div>
        )
      ) : (
        <>
          <Collapse defaultActiveKey={datos.almacenes.map((valorAlmacen) => valorAlmacen.proyectoId)} bordered={false}>
            {datos.almacenes.map((valorAlmacen) => (
              <Collapse.Panel key={valorAlmacen.proyectoId} header={<strong>{valorAlmacen.proyectoNombre}</strong>}>
                {valorAlmacen.insumos.map((valorInsumo, indice) => (
                  <div
                    key={`${valorInsumo.insumoId}_${valorInsumo.ubicacionId || "sin"}_${indice}`}
                    style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, marginBottom: 10, paddingBottom: 10, borderBottom: "1px solid #f0f0f0" }}
                  >
                    <div>
                      <strong>{valorInsumo.clave}</strong> - {valorInsumo.descripcion}
                      <div>
                        <Text type="secondary" style={{ fontSize: 12 }}>Cantidad: {valorInsumo.cantidad}</Text>
                      </div>
                    </div>
                    {valorInsumo.ubicacionId ? (
                      <Tag color="blue">{valorInsumo.ubicacionClave}{valorInsumo.ubicacionNombre ? ` - ${valorInsumo.ubicacionNombre}` : ""}</Tag>
                    ) : (
                      <Tag color="red">Sin ubicación asignada</Tag>
                    )}
                  </div>
                ))}
              </Collapse.Panel>
            ))}
          </Collapse>
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
            <ButtonItem onClick={onClose}>Cerrar</ButtonItem>
          </div>
        </>
      )}
    </ModalItem>
  );
};

export default ModalUbicacionesConfirmadas;
